import { render, staticRenderFns } from "./MoblieCommentMessage.vue?vue&type=template&id=6f515149&scoped=true&"
import script from "./MoblieCommentMessage.vue?vue&type=script&lang=js&"
export * from "./MoblieCommentMessage.vue?vue&type=script&lang=js&"
import style0 from "./MoblieCommentMessage.vue?vue&type=style&index=0&id=6f515149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f515149",
  null
  
)

export default component.exports